import styled from 'styled-components';
import {
  neutral80,
  pxToRem,
  spacing2,
  spacing3,
} from '@leaftrade/leaftrade-component-library';

export const CheckoutPaymentInlineInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing2};
  margin-bottom: ${spacing3};

  p {
    margin: 0 !important;
  }
`;

export const CheckoutPaymentBlock = styled.div`
  svg {
    width: ${pxToRem(18)};
    height: ${pxToRem(18)};
    fill: ${neutral80.hex};
  }

  p {
    margin-bottom: ${spacing2};
  }
`;
